 import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import * as yup from "yup";


export interface IMerchantConsultationDatatableFilterFormMeta {
  bank: FormInputMeta,
  agency: FormInputMeta,
  status: FormInputMeta,
  promo: FormInputMeta,
  MCC: FormInputMeta,
  parentGroup: FormInputMeta,
  DBAName: FormInputMeta,
  merchantId: FormInputMeta,
  DBAName2: FormInputMeta,
  requestId: FormInputMeta,
  iron: FormInputMeta,
  tpe: FormInputMeta,
  paymentMode: FormInputMeta,
  creationStartDate: FormInputMeta,
  creationEndDate: FormInputMeta,
  // Schema
  schema: any,
}

const MerchantConsultationDatatableFilterFormMeta = {} as IMerchantConsultationDatatableFilterFormMeta;


MerchantConsultationDatatableFilterFormMeta.bank = {
  name: 'bank',
  type: 'select',
  label: 'Banque',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantConsultationDatatableFilterFormMeta.agency = {
  name: 'agency',
  type: 'select',
  label: 'Agence',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantConsultationDatatableFilterFormMeta.status = {
  name: 'status',
  type: 'select',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantConsultationDatatableFilterFormMeta.promo = {
  name: 'promo',
  type: 'select',
  label: 'Promo',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

MerchantConsultationDatatableFilterFormMeta.MCC = {
  name: "MCC",
  type: "select",
  label: "MCC",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.parentGroup = {
  name: "parentGroup",
  type: "select",
  label: "Groupe parent",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.DBAName = {
  name: "DBAName",
  type: "text",
  label: "D/B/A Nom",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.merchantId = {
  name: "merchantId",
  type: "text",
  label: "ID Commercant",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.DBAName2 = {
  name: "DBAName2",
  type: "text",
  label: "D/B/A Nom",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.requestId = {
  name: "requestId",
  type: "text",
  label: "ID Commande",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.iron = {
  name: "iron",
  type: "checkbox",
  label: "Fer a repasser",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.tpe = {
  name: "tpe",
  type: "checkbox",
  label: "TPE",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.paymentMode = {
  name: "paymentMode",
  type: "select",
  label: "Mode paiement",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.creationStartDate = {
  name: "creationStartDate",
  type: "date",
  label: "Date creation Du",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
MerchantConsultationDatatableFilterFormMeta.creationEndDate = {
  name: "creationEndDate",
  type: "date",
  label: "Au",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};



MerchantConsultationDatatableFilterFormMeta.schema = yup.object().shape(getValidationSchema(MerchantConsultationDatatableFilterFormMeta));

export default MerchantConsultationDatatableFilterFormMeta;